const faqAccordion = document.querySelector('.faq-sec__container');

if (faqAccordion) {
  const faqItemsArr = document.querySelectorAll('.faq-sec__item');

  if (faqItemsArr.length) {
    const debounce = (func, wait) => {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

    const setContentHeight = (item) => {
      const contentEl = item.querySelector('.faq-sec__item-content');
      if (!contentEl) return;

      if (item.classList.contains('is-active')) {
        contentEl.style.maxHeight = '';
        const contentHeight = contentEl.scrollHeight + 40;
        contentEl.style.maxHeight = `${contentHeight}px`;
      } else {
        contentEl.style.maxHeight = '';
      }
    };

    const clearNextHoveredState = () => {
      faqItemsArr.forEach((faqItem) => {
        faqItem.classList.remove('is-next-hovered');
      });
    };

    const setPreviousAsNextHovered = (item) => {
      clearNextHoveredState();

      if (item?.previousElementSibling) {
        item.previousElementSibling.classList.add('is-next-hovered');
      }
    };

    const initFaqViewObserver = () => {
      faqItemsArr.forEach((item) => {
        item.setAttribute('data-view', '');

        [...item.children].forEach((child, index) => {
          child.style.setProperty('--faq-item-delay', `${index * 0.08}s`);
        });
      });

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        faqItemsArr.forEach((item) => item.classList.add('animated'));
        return;
      }

      const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('animated');
          currentObserver.unobserve(entry.target);
        });
      }, {
        threshold: 0.2,
        rootMargin: '0px 0px -8% 0px',
      });

      faqItemsArr.forEach((item) => {
        observer.observe(item);
      });
    };

    const openItem = (item) => {
      if (item.classList.contains('is-active')) return;

      faqItemsArr.forEach((otherItem) => {
        if (otherItem !== item && otherItem.classList.contains('is-active')) {
          closeItem(otherItem);
        }
      });

      item.classList.add('is-active');
      setContentHeight(item);
      setPreviousAsNextHovered(item);
    };

    const closeItem = (item) => {
      item.classList.remove('is-active');
      setContentHeight(item);

      const activeItem = [...faqItemsArr].find((faqItem) => faqItem.classList.contains('is-active'));

      if (activeItem) {
        setPreviousAsNextHovered(activeItem);
      } else {
        clearNextHoveredState();
      }
    };

    faqItemsArr.forEach((item) => {
      const toggleEl = item.querySelector('.faq-sec__item-toggle');
      const btnEl = item.querySelector('.faq-sec__item-btn');

      if (item.classList.contains('is-active')) {
        setContentHeight(item);
      }

      item.addEventListener('mouseenter', () => {
        setPreviousAsNextHovered(item);
      });

      item.addEventListener('click', () => {
        if (!item.classList.contains('is-active')) {
          openItem(item);
          return;
        }

        setPreviousAsNextHovered(item);
      });

      const closeElement = btnEl || toggleEl;
      if (closeElement) {
        closeElement.addEventListener('click', (e) => {
          if (item.classList.contains('is-active')) {
            e.stopPropagation();
            closeItem(item);
            return;
          }

          setPreviousAsNextHovered(item);
        });
      }
    });

    faqAccordion.addEventListener('mouseleave', () => {
      const activeItem = [...faqItemsArr].find((faqItem) => faqItem.classList.contains('is-active'));

      if (activeItem) {
        setPreviousAsNextHovered(activeItem);
      } else {
        clearNextHoveredState();
      }
    });

    initFaqViewObserver();

    const handleResize = debounce(() => {
      faqItemsArr.forEach((item) => {
        if (item.classList.contains('is-active')) {
          setContentHeight(item);
        }
      });
    }, 300);

    window.addEventListener('resize', handleResize);
  }
}
